/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { useEffect, useRef } from "react";

import { MediaStreamType } from "../../../shared/types";
import { usePlayerController } from "../../BasePlayer";
import { usePlayerCurrentMedia } from "../../Controller";
import { useCustomPlayerContext } from "../../CustomPlayerContext";

import "./SceenicOverlay.scss";

interface SceenicOverlayProps {
  userName?: string;
  userId?: string | number;
}

export const SceenicOverlay = ({ userName, userId }: SceenicOverlayProps) => {
  const { media, playInfo, streamType } = usePlayerCurrentMedia();
  const { player } = usePlayerController();
  const { plugins } = useCustomPlayerContext();

  const sceenicLoadedRef = useRef<boolean>(false);
  const overlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (
      plugins?.sceenic &&
      streamType !== MediaStreamType.Trial &&
      media?.CustomMetadata?.Sceenic?.Key &&
      overlayRef.current &&
      !sceenicLoadedRef.current
    ) {
      const video = document.getElementById(
        // @ts-ignore
        `${player.options.videoElement.id}`,
      );
      // @ts-ignore
      const enhancedVideoExperience = new EnhancedVideoExperience({
        target: video,
        username: userName,
        userId: userId,
        room: media.CustomMetadata?.Sceenic?.Room || playInfo.MediaId,
        key: media.CustomMetadata?.Sceenic?.Key,
        stream: media.CustomMetadata?.Sceenic?.Stream,
        lang: "en",
        modules: {
          chat: {
            enabled: true,
            target: document.getElementById("player-chat"),
          },
          polls: {
            enabled: true,
            target: document.getElementById("player-polls"),
          },
          cdn: {
            enabled: true,
            target: document.getElementById("player-cdn"),
          },
          reactions: {
            enabled: true,
            target: document.getElementById("player-reactions"),
          },
        },
      });

      const sceenicConfig = {
        username: userName,
        userId: userId,
        room: media.CustomMetadata?.Sceenic?.Room || playInfo.MediaId,
        key: media.CustomMetadata?.Sceenic?.Key,
        stream: media.CustomMetadata?.Sceenic?.Stream,
        lang: "en",
      };

      console.log("Sceenic Config", sceenicConfig);
      enhancedVideoExperience.init();
      sceenicLoadedRef.current = true;
    }
  }, [overlayRef.current]);

  if (
    !plugins?.sceenic ||
    streamType === MediaStreamType.Trial ||
    !media.CustomMetadata?.Sceenic?.Key
  ) {
    return null;
  }

  return (
    <div ref={overlayRef} className="SceenicOverlay">
      <div
        id="player-polls"
        className="SceenicOverlay__PollsSection"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      ></div>
      <div
        id="player-cdn"
        className="SceenicOverlay__CdnSection"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      ></div>
      <div
        id="player-chat"
        className="SceenicOverlay__ChatSection"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      ></div>
      <div
        id="player-reactions"
        className="SceenicOverlay__ReactionsSection"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      ></div>
    </div>
  );
};
